import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { DireccionComponent } from "../direccion/direccion";
import { validarEmail } from "app/logic/cliente";
import { Button } from "kea-react";

type Entity = models.DatosFacturacionNuevoCliente;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    nuevoCliente?: models.NuevoClienteDocumentacion
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        CodigoRegimenFiscal: validation.required

    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class DatosFacturacionNuevoClienteComponent extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));


    get rules(): validation.Rules<Entity> {
        return {};
    }

    arregloCadena = (props: Props) => props.value.CorreoFacturacion ? props.value.CorreoFacturacion.split(";") : [];
    arregloCorreos = createSelectorRx(this.arregloCadena, arreglo => arreglo.filter(x => x != undefined && x != "").map(x => ({ valido: validarEmail(x), correo: x })));

    onEliminarCorreo = async (index: number) => {
        const value = this.props.value;
        const arregloCorreos = this.arregloCorreos(this.props);
        var arreglos = arregloCorreos.filter((x, i) => index != i);
        const nuevoValueCorreo = arreglos.map(x => x.correo).join(";");
        const cambio: Partial<Entity> = { CorreoFacturacion: nuevoValueCorreo };
        await this.props.onChange({ ...value, ...cambio });
    }



// regresa un nuevo objetoo un clon, de las direciones del cliente
    cambiarDireccion (old:models.DatosFacturacionNuevoCliente, nuevoCliente: models.NuevoClienteDocumentacion | undefined)
                                :models.DatosFacturacionNuevoCliente{
        return {
            ... old,  
            Direccion: nuevoCliente.Direccion 
        };
    }
    
    onCopiar = () => {
        //1.- Obtener nuevoValue:
        const nuevoValue = this.cambiarDireccion(this.props.value ,this.props.nuevoCliente); 
        //2.- Lamar al onChange
        this.props.onChange(nuevoValue);
    }


    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Direccion = getField(DireccionComponent);
        const arregloCorreos = this.arregloCorreos(this.props);

        const CodigoRegimenFiscal = getField(selectores.CodigoRegimenFiscal);

        return (
            <div>

                <div className="panel panel-default">
                    <div className="panel-heading">
                        <span>
                            <i className={fa("credit-card")} />
                            Datos de facturación
                        </span>
                    </div>
                    <div className="panel-body">
                        {kea.autogrid(12, [
                            <div>
                                <p><strong>Correo de facturación</strong></p>
                                {
                                    arregloCorreos.map((x, i) => <span style={{ color: "black", backgroundColor: x.valido ? "#E3FBCA" : "#FBD2CA" }} className="badge">{x.correo} {' '} <kea.IconButton onClick={() => this.onEliminarCorreo(i)} style="danger" iconClass={fa("times")} />  </span>)
                                }
                                <Text field="CorreoFacturacion" label="" />,
                                <Text field="NombreFiscal" label="Nombre Fiscal" />,
                                <CodigoRegimenFiscal field="CodigoRegimenFiscal" label="Regimen Fiscal " />
                            </div>,
                        ])}
                        <Button onClick={this.onCopiar}>
                               Copiar direccion del Cliente
                        </Button>
                        <Direccion field="Direccion" />
                    </div>
                </div>

            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/nuevoclientedocumentacion/facturacion.tsx